import './WithdrawCancelButtonStyle.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';

type WithdrawCancelButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};
export const WithdrawCancelButton = (props: WithdrawCancelButtonProps) => {
  const { onClick, disabled } = props;
  return (
    <div className="withdrawCancelButton">
      <Button
        label="出金予約取消"
        fillType={FillType.primaryEmpty}
        buttonSize={ButtonSize.sizeS}
        disabled={disabled}
        onClick={onClick}
      />
    </div>
  );
};
